import { LIMIT_DEFAULT, OFFSET_DEFAULT, getData, isValid } from 'clients/Clients';
import { getAddressList, getLoyaltyList, getReferral, getUserLogGuide, postUserLogGuide, sendSmsToPhone } from 'clients/CustomerClient';
import { getPromotionListByIDs } from 'clients/PromoClient';
import { HTTP_STATUS } from 'constants/Enums/http';
import DateTimeUtils from 'utils/DateTimeUtils';
import { isEmpty } from 'utils/ValidateUtils';
import AddressService from './AddressService';

export const getReferralList = async ({ offset = OFFSET_DEFAULT, limit = LIMIT_DEFAULT }) => {
  const params = { offset, limit };
  const res = await getReferral({ params });
  if (isValid(res)) {
    res.data = res.data.map((referral) => {
      const { lastTimeSendSMS = null, smsTotalSent = 0, expireTime } = referral;

      // check expired
      if (DateTimeUtils.compareTime(expireTime, Date.now()) < 0) {
        return {
          ...referral,
          canResendSMS: false,
          message: 'Không thể gửi. Bạn đã quá thời hạn gửi đến số điện thoại này!',
        };
      }

      // check send total
      if (smsTotalSent >= 5) {
        return {
          ...referral,
          canResendSMS: false,
          message: 'Không thể gửi. Bạn không thể gửi quá 5 lần!',
        };
      }
      // check > 3h
      const dateLastSend = new Date(lastTimeSendSMS).getTime();
      const curTime = new Date().getTime();
      if (curTime - dateLastSend <= 10800000) {
        return {
          ...referral,
          canResendSMS: false,
          message: 'Chưa thể gửi lại. Trong vòng 3 giờ, bạn chỉ có thể gửi 1 tin SMS!',
        };
      }

      return { ...referral, canResendSMS: true };
    });
  }

  return res;
};

export const sendSms = async ({ phoneNumber }) => {
  if (isEmpty(phoneNumber)) {
    return { status: HTTP_STATUS.invalid, msg: 'Số điện thoại không đúng định dạng' };
  }
  return sendSmsToPhone({ phoneNumber });
};

export const getListAddressLite = async ({ ctx, params }) => {
  const res = await getAddressList({ ctx, params });
  if (!isValid(res)) return [];
  const data = getData(res);
  const addressInfoList = data.sort((a, b) => DateTimeUtils.compareTime(a.createdTime, b.createdTime));

  return addressInfoList;
};

export const getListAddress = async ({ ctx, params }) => {
  const res = await getAddressList({ ctx, params });
  if (!isValid(res)) return [];
  const data = getData(res);
  let addressInfoList = await Promise.all(
    data.map(async (info) => {
      const masterAddress = await AddressService.getMasterAddressString({ ctx, ...info });
      return { ...info, masterAddress: `${info.address}, ${masterAddress}` };
    }),
  );
  addressInfoList = addressInfoList.sort((a, b) => DateTimeUtils.compareTime(a.createdTime, b.createdTime));

  return addressInfoList;
};

export async function getListLoyalty({ ctx } = {}) {
  const res = await getLoyaltyList(ctx);
  if (!isValid(res)) return [];
  let loyaltys = getData(res);
  const promotionIDs = loyaltys.map((loyalty) => loyalty.promotionId);
  const promosResp = await getPromotionListByIDs({ ctx, promotionIDs });
  if (isValid(promosResp)) {
    const promoMap = {};
    const promos = getData(promosResp);
    promos.forEach((promo) => {
      promoMap[promo.promotionId] = promo;
    });
    loyaltys = loyaltys
      .map((loyalty) => ({
        ...loyalty,
        promotion: promoMap[loyalty.promotionId],
      }))
      .filter((loyalty) => DateTimeUtils.compareTime(loyalty?.promotion?.endTime, Date.now()) > 0)
      .sort((a, b) => a.point - b.point);
  }
  return loyaltys;
}

/**
 *
 * @param {string} feature
 * @returns
 */
export async function getMeGuide(feature) {
  const res = await getUserLogGuide({ q: { feature } });
  if (res.status !== 'OK') {
    console.error('[ERROR] Get guide', res);
    return {};
  }

  return res.data?.[0];
}

/**
 *
 * @param {object} param0
 * @param {string} param0.feature
 * @param {string=} param0.featureName
 * @param {boolean=} param0.isViewAll - true = user have clicked through all the guide
 * @returns
 */
export async function updateMeGuide({ feature, featureName, isViewAll }) {
  const res = await postUserLogGuide({ feature, featureName, isViewAll });
  if (res.status !== 'OK') {
    console.error('[ERROR] update guide', res);
  }

  return res;
}

export default {
  getReferralList,
  sendSms,
  getListAddress,
  getListAddressLite,
};

